import { USER_CALL_FETCH_REQUEST, USER_CALL_FETCH_SUCCESS, USER_CALL_FETCH_FAILURE } from './types';

const initialState = {
    loading: false,
    call: {},
    error: ''
}

const call = (state = initialState, action) => {
    switch (action.type) {
        case USER_CALL_FETCH_REQUEST:
            return {
                loading: true,
                call: {},
                error: '',
            }
        case USER_CALL_FETCH_SUCCESS:
            return {
                loading: false,
                call: action.payload,
                error: ''
            }
        case USER_CALL_FETCH_FAILURE:
            return {
                loading: false,
                call: {},
                error: action.payload
            }
        default:
            return state
    }
}

export default call;